import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserFragmentDoc } from '../../fragments/__generated__/user';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type CreateUserMutationVariables = Types.Exact<{
  city?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name: Types.Scalars['String']['input'];
  email: Types.Scalars['String']['input'];
  active?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  company: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, name?: string | null, city?: string | null, email: string, active: boolean, company?: string | null, is_admin: boolean } | null };


export const CreateUserDocument = gql`
    mutation CreateUser($city: String, $name: String!, $email: String!, $active: Boolean, $company: String!, $password: String!) {
  createUser(
    name: $name
    city: $city
    email: $email
    active: $active
    company: $company
    password: $password
  ) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      city: // value for 'city'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      company: // value for 'company'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;